import { useState } from 'react';
import Modal from '../ui/Modal';

const TermsOfService = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button 
        onClick={() => setIsOpen(true)}
        className="hover:text-red-500 transition-colors duration-300"
      >
        Användarvillkor
      </button>
      
      <Modal 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)}
        title="Användarvillkor"
      >
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-bold mb-4">1. Allmänna villkor</h2>
            <p className="mb-4">
              Genom att använda RenGlans Städtjänster AB:s webbplats och tjänster godkänner du följande användarvillkor. Dessa villkor gäller för alla beställningar och avtal mellan dig som kund och RenGlans Städtjänster AB.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">2. Tjänstebeskrivning</h2>
            <p className="mb-4">
              RenGlans Städtjänster AB erbjuder professionella städtjänster för både privatpersoner och företag. Tjänsterna inkluderar men är inte begränsade till: hemstädning, kontorsstädning, flyttstädning och fönsterputs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">3. Bokning och avbokning</h2>
            <div className="space-y-4">
              <p>
                <strong>3.1 Bokning</strong><br />
                Bokningar görs via vår webbplats, telefon eller e-post. En bekräftelse skickas till den angivna e-postadressen.
              </p>
              <p>
                <strong>3.2 Avbokning</strong><br />
                Avbokning måste ske minst 24 timmar före den schemalagda städtillfället för att undvika avgift. Vid sen avbokning kan en avgift om 50% av städkostnaden debiteras.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">4. Priser och betalning</h2>
            <div className="space-y-4">
              <p>
                <strong>4.1 Priser</strong><br />
                Alla priser är i svenska kronor och inkluderar moms. Priserna kan komma att justeras med en månads varsel.
              </p>
              <p>
                <strong>4.2 Betalning</strong><br />
                Betalning sker via faktura med 30 dagars betalningsvillkor. Vid försenad betalning tillkommer ränta enligt räntelagen.
              </p>
              <p>
                <strong>4.3 RUT-avdrag</strong><br />
                För privatpersoner erbjuder vi RUT-avdrag enligt gällande regler. Kunderna ansvarar för att lämna korrekt personuppgifter för RUT-deklarationen.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">5. Ansvar och skadestånd</h2>
            <p className="mb-4">
              RenGlans Städtjänster AB ansvarar endast för skador som orsakats av vår personal under tjänsteutförandet. Vi ansvarar inte för skador orsakade av felaktig information från kundens sida eller för föremål av högt värde som inte specifikt nämnts vid bokningstillfället.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">6. Ångerrätt</h2>
            <p className="mb-4">
              Enligt distansavtalslagen har du som konsument 14 dagars ångerrätt från det att avtalet ingicks. Denna rätt gäller dock inte om tjänsten har påbörjats med ditt godkännande innan ångertiden löpt ut.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">7. Personuppgifter</h2>
            <p className="mb-4">
              Vi behandlar dina personuppgifter i enlighet med vår Integritetspolicy. Genom att använda våra tjänster godkänner du vår behandling av dina personuppgifter enligt denna policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">8. Övrigt</h2>
            <div className="space-y-4">
              <p>
                <strong>8.1 Force Majeure</strong><br />
                Parten befrias från ansvar för uppfyllelse av avtalet om förseningen eller avvikelsen beror på omständighet som är utom den berörda partens kontroll.
              </p>
              <p>
                <strong>8.2 Tvistelösning</strong><br />
                Tvister ska i första hand lösas genom förhandling. Om förhandling inte leder till lösning ska tvisten prövas enligt svensk lag vid Stockholms tingsrätt.
              </p>
              <p>
                <strong>8.3 Ändring av villkor</strong><br />
                RenGlans Städtjänster AB förbehåller sig rätten att ändra dessa villkor när som helst. Uppdaterade villkor publiceras på vår webbplats och träder i kraft omedelbart efter publicering. Det är kundens ansvar att regelbundet granska villkoren för eventuella ändringar.
              </p>
            </div>
          </section>
          
          <p className="text-sm text-gray-500 mt-8">Senast uppdaterad: 16 december 2025</p>
        </div>
      </Modal>
    </>
  );
};

export default TermsOfService;
